function GeneratehashID(hashString:string) {
    return hashString.split('').reduce((prevHash, currVal) =>
        (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
}

export class DatalogIdentifierOptions {
    widgetId = '';
    key = -1;
    familyType = -1;
    siteId = 1;
    standardCalculation: null| {groupby:string, calculation:string} = null;
    normalizationKey = -1;
    normalizationConstant: null | {constant: string, unit: string} = null;
    reportPeriod : string = "0D";
}

export class Identifier {
    type = 'datalog';
    keytype= 'primarykey';
    key = -1;
    reportPeriod = '0D';
    calculation = 'raw';
    groupby = 'none';
    axis = 'y';
    hash = 0;
    dataHash = 0;
    color = '#000000';
    widgetType = 'chart';
    lastFetchTime = '';
    isDashboard = false;
    states = [];
    analogConditionalLimits = [];
    analogLimits = [];
    showOutliersOnly = false;
    returnAsPercent = false;
    selectedSiteNames = [];
    selectedFamilyTypes = [];
    selectedAlarmCategories = [];
    selectedAcknowledgementStatus = [];
    degreeDayCalcPeriod = '';
    degreeDayThreshold = '';
    degreeDayThresholdUnitId = 0;
    degreeDayNormProp = null;
    degreeDayType = '';
    widgetId = '';
    normalizationKey = -1;
    timeZn = 7;
    familyType = -1;
    buildingId = -1;
    normalizationConstant?:number = undefined;
    normalizationUnit?:string = undefined;
    dimensionUnit=null;
    equipProp=null;
    normalizationProp=null;
    pieType=null;
    reportShortTimePeriod=null;
    timeComparisons=null;

    // typescript def to allow iteration over object
    [key:string]:any;

    public static GenerateHash(ident:Identifier) {
        let searchTermsArray = [
            "axis",
            "calculation",
            "degreeDayNormProp",
            "degreeDayCalcPeriod",
            "degreeDayThreshold",
            "degreeDayType",
            "dimensionUnit",
            "equipProp",
            "groupby",
            "key",
            "keytype",
            "normalizationKey",
            "normalizationConstant",
            "normalizationUnit",
            "normalizationProp",
            "pieType",
            "reportPeriod",
            "reportShortTimePeriod",
            "timeComparisons",
            "type",
            "widgetId",
            "widgetType"
        ];
        let tempstr = '';
        for (let searchkey of searchTermsArray) {
            if (ident.hasOwnProperty(searchkey)) {
                tempstr += ident[searchkey];
            }
        }
        ident.hash = GeneratehashID(tempstr);

    }

    constructor() {
    }
    

    public static GeneratePrimaryKeyDatalogIdentifier(data : DatalogIdentifierOptions) {
        let ident = new Identifier();
        ident.dataHash = new Date().valueOf()+Math.floor(Math.random() *  1000);
        ident.widgetId = data.widgetId;
        ident.key = data.key;
        ident.familyType = data.familyType;
        ident.buildingId = data.siteId;
        ident.reportPeriod = data.reportPeriod;

        if (data.standardCalculation) {
            ident.groupby = data.standardCalculation.groupby;
            ident.calculation = data.standardCalculation.calculation;
        }

        if (data.normalizationConstant) {
            ident.normalizationConstant = parseInt(data.normalizationConstant.constant);
            ident.normalizationUnit = data.normalizationConstant.unit;
        }

        if (data.normalizationKey)
            ident.normalizationKey = data.normalizationKey;

        Identifier.GenerateHash(ident);

        return ident;
    }
  
}

